// The quantities typed into one card.
//
// Deliberately owned by the card and thrown away with it. A basket half-filled out of
// sight and submitted later is exactly the "something happened that I did not mean"
// failure the rest of this design exists to prevent — so nothing here is persisted, and
// leaving the screen loses it.

export class CardState {
  private quantities = $state<Record<string, number>>({});

  get(itemId: string): number {
    return this.quantities[itemId] ?? 0;
  }

  set(itemId: string, value: number): void {
    const clamped = Math.max(0, Math.min(999, Math.round(value)));
    this.quantities = { ...this.quantities, [itemId]: clamped };
  }

  /** Only what was actually asked for. Zero means "not this one", not "none of it". */
  chosen(): { itemId: string; quantity: number }[] {
    return Object.entries(this.quantities)
      .filter(([, quantity]) => quantity > 0)
      .map(([itemId, quantity]) => ({ itemId, quantity }));
  }

  clear(): void {
    this.quantities = {};
  }
}
